import React, { useEffect } from 'react';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import SearchPopup from '../components/SearchPopup';
import Footer from '../components/Footer';
import PageHeader from '../components/PageHeader';
import AboutPage from '../components/AboutPage';
import ServicesOne from '../components/ServicesOne';
import CausesOne from '../components/CausesOne';
import VideoOne from '../components/VideoOne';
import TeamOne from '../components/TeamOne';
import TestimonialOne from '../components/TestimonialOne';
import BlogOne from '../components/BlogOne';
import GalleryOne from '../components/GalleryOne';

const About = () => {
  useEffect(() => {
    // Ensure body has required class for custom cursor
    document.body.classList.add('custom-cursor');

    // Hide preloader in SPA context
    const hidePreloader = () => {
      if (window.$) {
        const $ = window.$;
        $('.preloader, .loader, .js-preloader').fadeOut(500);
      } else {
        const pr = document.querySelector('.js-preloader');
        if (pr) pr.style.display = 'none';
      }
    };
    if (document.readyState === 'complete') {
      hidePreloader();
    } else {
      window.addEventListener('load', hidePreloader);
    }
    return () => window.removeEventListener('load', hidePreloader);
  }, []);

  useEffect(() => {
    // AOS/WOW
    if (window.AOS && typeof window.AOS.init === 'function') {
      window.AOS.init({ duration: 1200, easing: 'ease', mirror: true });
    }
    if (window.WOW && typeof window.WOW === 'function') {
      try {
        const wow = new window.WOW({ boxClass: 'wow', animateClass: 'animated', mobile: true, live: true });
        wow.init();
      } catch (_) {}
    }

    // jQuery plugin inits
    if (window.$) {
      const $ = window.$;

      // Services: no carousel; Causes, Testimonials, Gallery need carousels
      // Causes carousel
      if ($('.causes-one__carousel').length && typeof $('.causes-one__carousel').owlCarousel === 'function' && !$('.causes-one__carousel').hasClass('owl-loaded')) {
        $('.causes-one__carousel').owlCarousel({
          loop: true,
          margin: 30,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 2 }, 992: { items: 3 }, 1200: { items: 3 }, 1320: { items: 3 } }
        });
      }

      // Testimonial (thumb + main)
      if ($('.testimonial-one__carousel').length && $('.testimonial-one__thumb-carousel').length) {
        const $big = $('.testimonial-one__carousel');
        const $thumbs = $('.testimonial-one__thumb-carousel');
        if (!$big.hasClass('owl-loaded')) {
          $big.owlCarousel({ items: 1, slideSpeed: 2000, nav: false, autoplay: true, dots: false, loop: true }).on('changed.owl.carousel', syncPosition);
        }
        if (!$thumbs.hasClass('owl-loaded')) {
          $thumbs.on('initialized.owl.carousel', function () { $thumbs.find('.owl-item').eq(0).addClass('current'); }).owlCarousel({ items: 4, dots: true, nav: false, smartSpeed: 700, slideBy: 4 }).on('changed.owl.carousel', syncPosition2);
        }
        function syncPosition(el) {
          const count = el.item.count - 1;
          let current = Math.round(el.item.index - el.item.count / 2 - 0.5);
          if (current < 0) current = count;
          if (current > count) current = 0;
          $thumbs.find('.owl-item').removeClass('current').eq(current).addClass('current');
          const onscreen = $thumbs.find('.owl-item.active').length - 1;
          const start = $thumbs.find('.owl-item.active').first().index();
          const end = $thumbs.find('.owl-item.active').last().index();
          if (current > end) $thumbs.data('owl.carousel').to(current, 500, true);
          if (current < start) $thumbs.data('owl.carousel').to(current - onscreen, 500, true);
        }
        function syncPosition2(el) {
          const number = el.item.index;
          $big.data('owl.carousel').to(number, 500, true);
        }
        $thumbs.on('click', '.owl-item', function (e) {
          e.preventDefault();
          const number = $(this).index();
          $big.data('owl.carousel').to(number, 500, true);
        });
      }

      // Gallery carousel
      if ($('.gallery-one__carousel').length && typeof $('.gallery-one__carousel').owlCarousel === 'function' && !$('.gallery-one__carousel').hasClass('owl-loaded')) {
        $('.gallery-one__carousel').owlCarousel({
          loop: true,
          margin: 5,
          nav: false,
          dots: false,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 2 }, 992: { items: 3 }, 1200: { items: 4 }, 1320: { items: 5 } }
        });
      }

      // Video popups
      if ($('.video-popup').length && typeof $('.video-popup').magnificPopup === 'function') {
        $('.video-popup').magnificPopup({ type: 'iframe', mainClass: 'mfp-fade', removalDelay: 160, preloader: true, fixedContentPos: false });
      }
      // Footer widget (Twitter) carousel
      if ($('.footer-widget__carousel').length && typeof $('.footer-widget__carousel').owlCarousel === 'function' && !$('.footer-widget__carousel').hasClass('owl-loaded')) {
        $('.footer-widget__carousel').owlCarousel({
          loop: true,
          margin: 0,
          nav: false,
          dots: true,
          smartSpeed: 500,
          autoplay: true,
          autoplayTimeout: 7000,
          responsive: { 0: { items: 1 }, 768: { items: 1 }, 992: { items: 1 }, 1200: { items: 1 }, 1320: { items: 1 } }
        });
      }
    }
  }, []);
  

  return (
    <>
      {/* Utility overlays expected by template */}
      <MobileNav />
      <SearchPopup />

      {/* Custom cursors */}
      <div className="custom-cursor__cursor"></div>
      <div className="custom-cursor__cursor-two"></div>

      {/* Preloader */}
      <div className="loader js-preloader"><div></div><div></div><div></div></div>

      <div className="page-wrapper">
        <Header />
        <PageHeader />
        <AboutPage />
        <ServicesOne />
        <CausesOne />
        <VideoOne />
        <TeamOne />
        <TestimonialOne />
        {/* <BlogOne /> */}
        <GalleryOne />
        <Footer />
      </div>
    </>
  );
};

export default About;
